import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from 'syf-component-library/ui/atoms/Button';
import { ModalContent } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { detectDeviceType, setImagePath } from '../../utils/helpers';
import { CANCEL_POPUP_EVENT } from '../../utils/analytics/analyticsEvents';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { getCancelModalContent } from '../../store/contentSlice';
import { CancelModalInterface } from '../../interfaces/CancelModal.interface';
import '../sessionTimeout/sessionTimeout.css';

const CancelModal: React.FC<CancelModalInterface> = ({
  onClose,
  onConfirm,
}) => {
  const { cancelHeading, noButtonLabelText, yesButtonLabelText }: any =
    useSelector(getCancelModalContent);

  useEffect(() => {
    capturePageLoadAnalytics(CANCEL_POPUP_EVENT);
  }, []);

  return (
    <div className="pop-up" data-testid="session-timeout-popup">
      <ModalContent className="pop-up-container" role="dialog">
        <div className="session-timeout-image-wrapper">
          <img
            src={setImagePath('timeout-warning')}
            alt="cancel pop-up message"
          />
        </div>
        <span className="pop-up-header">{cancelHeading}</span>
        <div className="buttons-container">
          <Button
            data-reason="Yes-cancelPopUp"
            data-type={detectDeviceType}
            data-object="button"
            buttonType="primary"
            className="button"
            onClick={onConfirm}
            data-testid="yes-cancel-button"
          >
            {yesButtonLabelText}
          </Button>
          <Button
            test-data="no-cancel-button"
            data-reason="No-cancelPopUp"
            data-type={detectDeviceType}
            data-object="button"
            buttonType="ghost"
            onClick={onClose}
            data-testid="no-cancel-button"
          >
            {noButtonLabelText}
          </Button>
        </div>
      </ModalContent>
    </div>
  );
};

export default CancelModal;
